/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TermsAndConditions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Body from 'DesignSystem/Body/index'
import React from 'react'
import Title from 'DesignSystem/Title/index'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TermsAndConditions({
  children,
  viewPath = "/App/Auth/TermsAndConditions"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="TermsAndConditions.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-Z1ahxhm': isMedia.mobile ? "100%" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TermsAndConditions.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-3-Z1ahxhm': isMedia.mobile ? "10px" : "30px",'--pr-4-Z1ahxhm': isMedia.mobile ? "10px" : "30px",'--mw-2-Z1ahxhm': isMedia.mobile ? "100%" : "700px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../SignIn'))}
 marginTop={isMedia.mobile ? "0px" : "0px"}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Back"
/>
)}
</TysiaButton>
</div>
<div
  data-testid="TermsAndConditions.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="TermsAndConditions.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-3-Z1ahxhm': isMedia.mobile ? "10px" : "30px",'--pr-4-Z1ahxhm': isMedia.mobile ? "10px" : "30px",'--w-1-Z1ahxhm': isMedia.mobile ? "100%" : "700px"}}
 className={`views-block ${styles.Vertical2}`}
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 text="Terms of Use Agreement"
 marginTop={30}
 fontSize={40}
 marginBottom={0}
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceM}
 text="This Terms of Use Agreement (“Terms of Use” or “Terms of Use Agreement”) governs your access and use of the software, applications, and services as described below."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Ownership and Purpose of the Websites and Applications"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH, LLC (“GREYFINCH”) owns and operates various websites and applications related to electronic medical records (“EMR”), software for EMR and healthcare practice management (“EMR Software”), and other related online products and services. These products and services include the GREYFINCH Patient Portal, and other patient health portals powered by GREYFINCH, and any other current or future websites or mobile access or applications. These websites and applications are collectively referred to herein as the “Services.”"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The purpose of the Services is to provide a secure network that will assist patients in managing their medical records, prescriptions, doctors' appointments and other healthcare related items online and/or from their mobile devices in order to assist them in obtaining improved quality, safety, and efficiency of healthcare. This includes providing a means of interacting with GREYFINCH, LLC's EMR Software and other EMR-related products and services which one of more of each patient's healthcare providers utilize. The Services may interact with other websites, applications, and portals owned and operated by GREYFINCH or its affiliates including Direct Dental Care (the “Affiliated Services”)."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Terms and Conditions"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="This Terms of Use defines the terms and conditions under which GREYFINCH makes the Services available. BY USING THE SERVICES AND/OR DOWNLOADING OR USING ANY WEBSITES OR APPLICATIONS RELATED TO THE SERVICES, YOU AGREE TO THESE TERMS OF USE. These Terms of Use, including the related Privacy Policy, take effect when you use the Services or otherwise affirm acceptance. IF YOU DO NOT AGREE, DO NOT USE THE SERVICES (INCLUDING ANY RELATED WEBSITES OR APPLICATIONS) OR ANY PART THEREOF. When first using different products or services covered by this Terms of Use, You may be presented again with this Terms of Use."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="These Terms of Use are a legally binding agreement made by and between GREYFINCH and you (whether you are joining for yourself or on behalf of a minor or a person to whom you are a caregiver) (“You” and as the context provides, “Your” and “Yourself”). These Terms of Use govern Your access and/or use of the Services and You should read them carefully. This Terms of Use Agreement shall remain in effect at all times until You cease using the Services and delete all applications related to the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="BY REGISTERING FOR ACCESS, ACCESSING, OR USING THE SERVICES OR BY DOWNLOADING AND REGISTERING FOR ACCESS, ACCESSING, OR USING ANY RELATED APPLICATION(S), YOU AGREE THAT YOU HAVE READ, UNDERSTOOD, AND AGREED TO BE BOUND BY THESE TERMS OF USE AND OUR PRIVACY POLICY. IF YOU DO NOT AGREE TO BE SO BOUND, DO NOT ACCESS, DOWNLOAD, OR USE THE SERVICES OR ANY RELATED WEBSITES OR APPLICATIONS."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH reserves the right, at its sole discretion, to make changes to portions or all of these Terms of Use and the Privacy Policy at any time. You are responsible for checking these Terms of Use and the Privacy Policy periodically for changes. Your continued use of the Services means that You agree to any new or modified provision of these Terms of Use or the Privacy Policy accessible through the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Content and Intellectual Property Information"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The GREYFINCH family owns the common law rights in “Greyfinch” and “Direct Dental Care”, and other marks. These marks may not be used without the express, written permission of GREYFINCH. Any third party trademark(s) that may appear on or in connection with the Services are the property of their respective owner(s)."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The proprietary contents of the Services include, without limitation, the animations, applets, audio, data, design, graphics, illustrations, images, information, marks, music, photographs, text, video, and any other files displayed, used and/or available on or through the Services (the “Content”), as well as the arrangement, coordination, design, expression, look and feel, selection, and structure of such Content. The Content is owned, controlled, or licensed by or to GREYFINCH, and is protected by copyright, trade dress, trademark, and other intellectual property rights and unfair competition laws. GREYFINCH reserves all rights, title, and interests in the Content and the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Except as expressly provided in these Terms of Use or by GREYFINCH's express written consent, no part of the Services and no Content may be copied, modified, reformatted, leased, loaned, sold, distributed, encoded, posted, publicly displayed, published, republished, reproduced, creative works derived from, translated, uploaded, or otherwise exploited in any manner."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Digital Millennium Copyright Notice and Other Reports of Infringement"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Pursuant to 17 U.S.C. § 512(c)(2) (known as the Digital Millennium Copyright Act of 1998), You may contact GREYFINCH to report the infringement of any intellectual property right through GREYFINCH's designated agent:"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Joseph W. Gregory, Esq., Joseph Gregory Law, PLLC, 500 Shall Avenue, Suite C, Little Rock, Arkansas 72202, 501-952-1887 (telephone), joearklaw@gmail.com"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Please do not contact GREYFINCH's designated agent for technical support issues; contact Your applicable healthcare provider or GREYFINCH. Any such technical support requests sent to the above designee may not be responded to or even received by GREYFINCH."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Access and Use of the Services"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services are intended to be used by individuals whose healthcare providers are provided services from GREYFINCH or its affiliates, and all other individuals who wish to use the Services' functionality in connection with their medical care and wellbeing. To begin use of the Services, You may be asked to provide information about Yourself (or the person on whose behalf You are accessing, using or downloading the Services, including all related websites and applications). If You are under 18 years old, please discuss whether You should use and download the Services with Your physician and/or Your parent(s) or guardian(s). To use the Services, You must be a resident of the 50 States of the United States of America, exclusive of its commonwealths, territories, and possessions. To access or use the Services, You may be required to provide GREYFINCH with information relating to Your identity and certain other information, including Your email address. By submitting such information to GREYFINCH, You hereby certify that any and all information provided to GREYFINCH by You is true and correct and You authorize GREYFINCH to use any method it chooses to verify the truth and accuracy of the information that You provide to the extent GREYFINCH needs to do so to protect its rights or other users of the Services. Failure to provide truthful and accurate information to GREYFINCH may result in termination of Your access to the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services requires a valid, working email address and other information to initially set up Your access to the Services. (Some functionality may not require You to set up an account; such functionality is not subject to the same security and protections as the functions available to account holders who access the Services through their accounts using their password or PIN). Additionally, You will be required to create a username, password and/or PIN number to securely access the Services. Current users of certain of the Services may be allowed to use their current log-in credentials to access the Services and all users may have the ability to “link” their various accounts together through the Services and any Affiliated Services or applications. You are solely responsible for maintaining the strict confidentiality of the username, password, and/or PIN You use to access the Services. This responsibility includes not allowing another person to use Your credentials to access the Services. You will be solely responsible for any damages or losses that may be incurred or suffered as a result of Your failure to maintain the strict confidentiality of Your username and password. You should immediately inform GREYFINCH in writing of any need to deactivate Your account due to potential or actual security concerns. GREYFINCH will not be liable for any harm related to the misappropriation of Your username, password and/or PIN, Your intentional or negligent disclosure of such items to another person, or Your authorization to allow another person or entity to access and use the Services under Your log-in credentials. You agree that you will not register for more than one account for any specific product or service, including each website and application which may be available. You are prohibited from utilizing alter-egos or other disguised identities when accessing the Services. All forms of indirect and “spoofed” access are strictly prohibited."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH uses the means it believes are reasonable to provide access to the Services 24 hours a day, 7 days a week, except in the case of natural disasters, events beyond GREYFINCH's control, and any necessary repair or maintenance operations required for the smooth operation of the Services. GREYFINCH shall not be liable for any failure or deficiency in the performance of the Services for any reason whether such reason be maintenance, breakdown or any event beyond GREYFINCH's reasonable control including, without limitation: fire, Internet outage, interruption of service, labor disturbance, natural disaster, technological disaster, terrorism, or war."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You acknowledge that data conversion and transmission is subject to the likelihood of human and machine errors, omissions, delays and losses, including inadvertent loss of data or damage to media, that may give rise to loss or damage. GREYFINCH shall not be liable for any such errors, omissions, delays, or losses. You understand and agree that use of or connection to the Internet through the Services and/or use of mobile devices is inherently insecure and that connection to the Internet and/or use of mobile devices provides opportunity for unauthorized access by a third party to computer systems, mobile devices, networks, and any and all information stored therein.  All information transmitted and received through the Services, the Internet, or through mobile devices is subject to unauthorized interception, diversion, corruption, loss, access, and disclosure. GREYFINCH shall not be responsible for any adverse consequences whatsoever of Your connection to or use of the Services, the Internet, or mobile devices, and shall not be responsible for any use by You of an Internet connection in violation of any law, rule, or regulation, or any violation of the intellectual property rights of another."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Medical Disclaimers; No Provider/Patient Relationship; Provider Information"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Use of the Services and/or any information or Content that is included on or transmitted through the Services is not intended to and will not create any healthcare provider/patient relationship of any kind involving GREYFINCH or its affiliates – this shall be true whether a user is utilizing any provider location services, links to Affiliated Services or applications, or other websites and any other manner in which the Services may assist a user in locating a medical professional."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Communications between patients and healthcare providers may not occur, and cannot be guaranteed to occur, in real-time."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Any Content available on or through the Services is for informational and educational purposes only and is not a substitute for the professional judgment of a healthcare professional in diagnosing and treating patients. Neither the Content nor any other service offered by or through the Services is intended to be substituted for medical diagnosis or treatment. GREYFINCH does not recommend or endorse any specific drugs, tests, physicians, products, procedures, opinions, “off-label” drug uses or other information that may be mentioned on or transmitted through the Services (regardless if the foregoing is mentioned or transmitted by healthcare providers, insurance providers, or similar professionals or organizations). Your reliance upon any information obtained or used by You is solely at Your own risk. GREYFINCH is not responsible for the accuracy of any information or content provided or sent by You or other users of the Services, including Your physician, other healthcare providers, insurance providers, or their representatives. You are responsible for verifying the accuracy of any information You send or receive through the Services, including any of Your patient health information, data, or records. IF YOU HAVE AN EMERGENCY, DO NOT USE THE SERVICES TO CONTACT YOUR HEALTHCARE PROVIDER – INSTEAD, YOU SHOULD IMMEDIATELY CALL 911 AND REQUEST EMERGENCY CARE ASSISTANCE."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH shall not be liable in any way to You for any decision You make or any actions that occur in connection with the use of the Services in locating and/or starting a relationship with a medical professional. GREYFINCH has no control over, and cannot guarantee the availability of any provider that is a part of the Services at any particular time. GREYFINCH will not be liable or responsible in any way for cancelled or otherwise unfulfilled appointments or any injury resulting therefrom, or for any other injury resulting from the use of the Services whatsoever."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You are strongly advised to perform an independent investigation prior to selecting a healthcare professional by making telephone calls to the appropriate licensing authorities to verify listed credentials and education, and to further verify information about a particular doctor or other healthcare provider (each, a “Provider”) by confirming with the Provider's office, your current Provider, the medical association relative to the Provider's specialty and your state medical board, and consulting other sources as may be appropriate."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH makes the Services available as a service to consumers and Providers for the purposes of providing an informative and educational resource. GREYFINCH may, but has no obligation to, review Content posted on the Services. It is important to note, however, that the timeliness and accuracy of any or all of the Content is not guaranteed. Neither the authors (whether users of the Services or not), GREYFINCH, nor any other party who has been involved in the preparation or publication of any Content can assure you that such Content is in every respect accurate or complete, and they are not responsible for any errors or omissions or for the results obtained from the use of such Content."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The procedures, products, services and devices discussed and/or advertised within the Services are not applicable to all individuals, patients or all clinical situations. GREYFINCH makes no claims as to the effectiveness of any such procedures, products, services or devices. Any products and/or services represented on the Services by advertisers, sponsors, and other Services participants, either paid or unpaid, are presented for Your awareness and do not necessarily imply appropriateness for any particular individual or prediction of effectiveness, outcome or success."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Compliance with Laws; Transmission of Data"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="With respect to its operation of the Services, and to the extent required by (i) the Health Insurance Portability and Accountability Act of 1996 (“HIPAA”) and the regulations promulgated thereunder, and (ii) the Health Information Technology for Economic and Clinical Health Act (“HITECH”) and any regulations promulgated thereunder (HIPAA and HITECH are collectively referred to herein as the “Privacy Laws”), GREYFINCH will fully comply with the Privacy Laws applicable to business associates and maintain the confidentiality of any Protected Health Information (as defined by the Privacy Laws) (“PHI”) transmitted or made available through the functionality of the Services or the Affiliated Services. You understand and agree that this Terms of Use Agreement may be amended from time to time if necessary to comply with the Privacy Laws. The requirements of this Section will survive the termination of Your use of the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="When You use the Services to upload, transmit, or receive PHI, You agree that, to the extent applicable, You shall comply with all applicable state and federal laws including, but not limited to, the Privacy Laws. You represent and warrant that You will, at all times, comply with all laws directly or indirectly applicable to You that may now or hereafter govern the gathering, use, transmission, processing, receipt, reporting, disclosure, maintenance, and storage of PHI. You agree that GREYFINCH, and all other persons or entities involved in the operation of the Services, have the right to monitor, retrieve, store, review, and use PHI, if applicable, in connection with the transmission of any PHI."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="To the extent permissible under the Privacy Laws and any other applicable Federal and State laws, You hereby grant to GREYFINCH a perpetual, unlimited license to use the data and information that is compiled or passes through the Services that specifically relates to You, Your patient care, Your Provider's procedures or diagnoses, or insurance provider procedures, policies, coverage, or payments, and any related information (collectively, the “Client Data”), in a de-identified format as defined under the Privacy Laws for data benchmarking, sharing, warehousing, resource utilization, and similar data analysis services; provided, however, that GREYFINCH shall comply with the Privacy Laws in connection with any such actions."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH CANNOT AND DOES NOT ASSUME ANY RESPONSIBILITY FOR YOUR USE OR MISUSE OF PHI OR OTHER INFORMATION TRANSMITTED, MONITORED, STORED OR RECEIVED WHILE USING THE SERVICES WHETHER TO A PROVIDER LOCATED USING THE SERVICES OR OTHERWISE. GREYFINCH RESERVES THE RIGHT TO AMEND OR DELETE ANY UPLOADED CONTENT (ALONG WITH THE RIGHT TO REVOKE ANY MEMBERSHIP OR RESTRICT ACCESS TO THE SERVICES) THAT IN GREYFINCH'S SOLE DISCRETION VIOLATES ANY PROVISIONS OF THIS SECTION OR THE TERMS OF USE IN GENERAL."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Prohibited Conduct"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You may only use the Services for lawful purposes. In Your access and use of the Services, You agree that You will not: (i) infringe any copyright, patent, right of privacy, right of publicity, trademark, trade secret, or other right of GREYFINCH or any third party; (ii) abuse, defame, harass, or stalk any individual or other user of the Services; (iii) interfere or attempt to interfere with, or damage or attempt to damage, the Services or the proper working of the Services, including, without limitation, through the use of cancel bots, denial of service attacks, flood pings, forged routing or electronic mail address information, harmful code, packet or IP spoofing, phishing, Trojan horses, viruses, or similar methods or technology; (iv) use any deep-link, page-scrape, robot, spider, or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the Services or any Content, or in any way reproduce or circumvent the navigational structure or presentation of the Services or any Content, to obtain or attempt to obtain any materials, documents or information through any means not purposely made available through the Services; (v) misrepresent Your identity, provide false information, impersonate another person or entity, misrepresent Your affiliation with a person or entity, including, without limitation, GREYFINCH, create or use a false identity, or attempt to use another user's account; (vi) attempt to obtain unauthorized access to any website or mobile device application through the Services; (vii) engage, directly or indirectly, in transmission of chain letters, junk mail, spam, or any other type of unsolicited solicitation; (viii) collect, reverse look-up, trace or seek to trace, manually or through automated means, information about other users of the Services without their express consent or other information relating to the Services; (ix) use any meta tags or any other hidden text utilizing the GREYFINCH names, service marks, trademarks, or product or service names; (x) advertise, offer to sell, or sell any goods or services set forth in the Services or otherwise use the Services to solicit other users, except as expressly permitted by GREYFINCH; (xi) engage in any activity that interferes with any third party's ability to use or enjoy the Services; (xii) probe, scan or test the vulnerability of the Services or any network connected to the Services, or breach the security or authentication measures on the Services or any network connected to the Services; (xiii) take any action that imposes an unreasonable or disproportionately large load on the infrastructure of the Services or GREYFINCH's systems or networks, or any systems or networks connected to the Services or GREYFINCH; or (xiv) assist any third party in engaging in any activity prohibited by these Terms of Use."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Communication of Other Information To and On the Services Websites and Applications"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services may at some point contain features that allow You to submit content or messages in the form of text, pictures, drawings, designs, graphics, audio clips, video clips, documents, or other files that are then accessed by other Services users or through the websites or applications (a “Posting”). If such functionality is available, You are prohibited from submitting any Posting that: (i) restricts or inhibits any other user from using and enjoying the Services or any Affiliated Services, in whole or in part; (ii) is abusive, defamatory, inaccurate, indecent, false, libelous, misleading, obscene, offensive, pornographic, profane, threatening, sexually explicit, vulgar, or unlawful in any manner; (iii) constitutes or encourages conduct that would constitute a criminal offense, gives rise to civil liability or otherwise violates any law, rule or regulation; (iv) violates, plagiarizes, or infringes the rights of third parties including, without limitation, copyright, trademark, patent, rights of privacy or publicity or any other proprietary right; (v) contains a virus or other harmful component; (vi) contains any information, software or other material of a commercial nature; (vii) contains advertising, promotions or commercial solicitations of any kind; or (viii) constitutes or contains false or misleading statements of fact."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="By submitting or authorizing any Posting, You are granting GREYFINCH a perpetual, worldwide, royalty-free, exclusive, sublicenseable and irrevocable right and license to use, copy, reproduce, distribute, perform, and display such Posting (and any information contained therein) and derivative works thereof, in whole or in part, in any form, media or technology known or hereafter developed as long as such use is consistent with GREYFINCH's applicable obligations set forth elsewhere in these Terms of Use. You hereby irrevocably waive any claims based on moral rights or similar doctrines and theories, and also based on right of privacy, misappropriation, right of publicity, unfair competition and similar doctrines, theories and torts."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You acknowledge that GREYFINCH will not pre-screen Postings, but that GREYFINCH and its designees have the right (but not the obligation) in their sole discretion to block or restrict access to or the availability of, or to edit, disable or remove, any Posting that is available via the Services or the Affiliated Services. By way of example and without limiting the foregoing, GREYFINCH and its designees may edit, disable, remove, or restrict access to or the availability of, any Posting that violates these Terms of Use or is required to be reviewed, monitored, edited or deleted by any court order, or in any governmental, administrative or judicial proceeding. You must evaluate and bear all risks associated with the use of any Postings, including any reliance on the accuracy, completeness, or usefulness of such Postings. GREYFINCH assumes no liability for use of any Posting by any third party."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Ads; Communications with Users; Links To Third Parties"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services may include sponsored advertising and You hereby agree and understand that by downloading and using the Services, you consent to the presence of sponsored ads and services on the Services, which advertising will be placed at GREYFINCH's sole discretion. Such ads may be placed vertically on the left or right side, or horizontally on the bottom, of any displayed page on the Services. Sponsored ads shall be clearly delineated from other content on the Services through the use of boxes surrounding the advertisement, a different colored background or other similar means and shall contain a header with the words similar to “Advertisement or Sponsorship.”"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="In addition to the foregoing advertising, GREYFINCH, through the Services or the contact information You have provided, may contact You regarding certain offers, products or services of GREYFINCH or other of its partners that GREYFINCH believes may be beneficial to You. You understand and agree that GREYFINCH may contact You in this manner. You may also be asked to grant an authorization for (i) GREYFINCH to use Your PHI in connection with its business partners and the advertising, offers, products or services that may be directed to You, and (ii) GREYFINCH to “push” notifications to You through Your mobile device(s). You may decide to authorize GREYFINCH to act in these manners by accepting such terms in the process of downloading and signing up for the Services. You will also have the authority to opt out of such use at any time by contacting GREYFINCH."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services may also contain links to the websites of GREYFINCH affiliates, partners, advertisers, or unrelated third party companies or links to other websites or mobile applications (collectively, “Linked Sites”)."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH does not own and has no control over the Linked Sites and therefore assumes no responsibility and makes no warranties or representations with respect to the availability of these websites or mobile applications, their content, advertising material, and the products or services available at or through the Linked Sites. GREYFINCH does not endorse any Linked Sites, is not bound by the terms and conditions, if any, of such Linked Sites, and the existence of a Linked Site does not mean that GREYFINCH has any affiliation, connections, endorsement, or sponsorship of such websites and mobile applications or their owners or operators. References or hypertext links made or included on the Services to any names, logos, or marks of third parties, including, without limitation, the Linked Sites' partners or Linked Sites' products and services, do not constitute or imply our endorsement, sponsorship, or recommendation. GREYFINCH accepts no liability for any direct or indirect damage that may result from Your visit to a Linked Site, or from Your use of the contents, products or services of these websites, mobile applications, or their owners or operators. Your use of a Linked Site will be subject to that Linked Site's terms of use, privacy policies, and other practices. We undertake no obligation to inform or update You regarding the terms and conditions of access, use or service, or the privacy policies of Linked Sites."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You acknowledge and agree that GREYFINCH shall not be responsible or liable for the content or conduct of, associated with, or related to any Linked Site, and, accordingly, Your access and use of any Linked Site shall be solely at Your own risk. If You have any questions or concerns regarding any Linked Site, You should review any terms and conditions and privacy policy maintained by that Linked Site, or contact the applicable party or their website administrator."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Privacy"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Services' Privacy Policy applies to use of the Services, its terms are hereby incorporated and made a part of these Terms of Use, and it can be accessed through the Services."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Your Representations, Warranties, and Indemnification to GREYFINCH"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You represent, warrant, and covenant to GREYFINCH that: (i) You have the full power and authority to enter into and perform Your obligations under these Terms of Use; (ii) Your assent to, and performance of, Your obligations under these Terms of Use do not constitute a breach of or conflict with any other agreement or arrangement by which You are bound, or any applicable federal or state laws; (iii) You are able to form a legally binding contract, and these Terms of Use constitute legal, valid, and binding obligations on You, enforceable in accordance with their terms; (iv) You will not infringe the patent, copyright, trademark, trade secret, right of privacy, right of publicity, or other intellectual property or proprietary right of GREYFINCH or any third party in Your use of the Services or any Affiliated Services; (v) You have provided complete, truthful, and accurate information about Yourself for purposes of downloading, joining, and using the Services; (vi) You are not using, and will not use, the Services, any Affiliated Services, or any information contained therein for any improper, harassing, or unlawful purpose; (vii) You will comply with all applicable federal and state laws in Your use of the Services and the Affiliated Services, including these Terms of Use; and (viii) You are not a paid consultant or have any other financial interests in the information You provide on the Services or any Affiliated Services including, but not limited to, the promotion of “off label” drug uses, the disclosure of the results of confidential clinical trials or any other proprietary information."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You agree to indemnify and hold GREYFINCH and its owners, employees, representatives, agents, attorneys, affiliates, directors, officers, members, and managers (“Indemnified Parties”) harmless from any and all damages, losses, costs, or expenses (including without limitation, attorney's fees and costs) incurred in connection with any third-party claim, demand or action (“Claim”) brought or asserted against any of the Indemnified Parties: (i) alleging facts or circumstances that would constitute a breach by You of any provision of these Terms of Use; (ii) arising from, related to, or connected with Your use of the Services, any Affiliated Services and/or its Content; or (iii) arising from, related to, or connected with Your non-compliance with any laws including, but not limited to, the Privacy Laws."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Disclaimers, Exclusions and Limitations"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="As used below in this section, “GREYFINCH” refers to GREYFINCH, LLC, and its owners, employees, representatives, agents, attorneys, affiliates, directors, officers, members, managers, volunteers, and suppliers."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="DISCLAIMER OF WARRANTIES"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="THE SERVICES, CONTENT AND ANY INFORMATION INCLUDED ON OR PROVIDED THROUGH THE SERVICES OR THE AFFILIATED SERVICES (INCLUDING ALL RELATED WEBSITES AND APPLICATIONS) ARE PRESENTED ON AN “AS IS” BASIS, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. GREYFINCH DISCLAIMS ALL WARRANTIES AND CONDITIONS, EITHER EXPRESS, IMPLIED, OR STATUTORY INCLUDING, BUT NOT LIMITED TO, ANY IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND LACK OF NEGLIGENCE OR WORKMANLIKE EFFORT."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="WITHOUT LIMITING THE FOREGOING PROVISIONS:"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(1) YOU ASSUME SOLE RESPONSIBILITY FOR SELECTING THE SERVICES AND/OR THEIR CONTENT TO ACHIEVE YOUR INTENDED RESULTS AND SOLE RESPONSIBILITY FOR THE USE OF, AND RESULTS OBTAINED FROM, THE SERVICES AND/OR THEIR CONTENT;"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(2) GREYFINCH MAKES NO REPRESENTATION OR WARRANTY THAT THE SERVICES, ANY AFFILIATED SERVICES AND/OR ANY CONTENT WILL BE ERROR-FREE, SECURE, VIRUS FREE, OR FREE FROM INTERRUPTIONS, DEFECTS OR OTHER FAILURES OR HARMFUL COMPONENTS OR THAT THE SERVICES, ANY AFFILIATED SERVICES AND/OR THEIR CONTENT WILL SATISFY YOUR SPECIFIC REQUIREMENTS OR BE COMPATIBLE WITH YOUR EQUIPMENT (MOBILE OR OTHERWISE) OR OTHER HARDWARE, SOFTWARE OR BROWSER CONFIGURATION OR THAT INACCURACIES OR ERRORS WILL BE CORRECTED;"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(3) GREYFINCH MAKES NO REPRESENTATION OR WARRANTY THAT THE INFORMATION OBTAINED FROM THIRD PARTY SOURCES (INCLUDING, BUT NOT LIMITED TO, ANY USERS OF THE SERVICES) USED ON OR WITHIN THE SERVICES OR ANY AFFILIATED SERVICES OR RECEIVED IN CONNECTION WITH CONVERTING OR TRANSMITTING ANY DATA RECEIVED IN DIFFERENT FORMATS IS ACCURATE, TIMELY, OR ERROR FREE, AND GREYFINCH IS NOT RESPONSIBLE IN ANY WAY FOR THE INFORMATION OBTAINED FROM SUCH SOURCES;"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(4) GREYFINCH MAKES NO REPRESENTATION OR WARRANTY THAT THE INFORMATION PROVIDED BY USERS TO GAIN ACCESS AND PERMISSION TO USE THE SERVICES, ANY AFFILIATED SERVICES, OR OTHER INFORMATION POSTED BY USERS IS ACCURATE OR ERROR FREE; AND"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(5) GREYFINCH MAKES NO REPRESENTATION OR WARRANTY REGARDING THE SUITABILITY OF ANY PERSONS PARTICIPATING IN THE SERVICES OR THE AFFILIATED SERVICES OR REGARDING THE CHARACTER OR INTEGRITY OF SUCH PERSONS."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="SOME STATES AND JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU. THE FOREGOING PROVISIONS SHALL BE ENFORCEABLE TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="LIMITATION OF LIABILITY AND EXCLUSION OF DAMAGES"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY SHALL GREYFINCH OR THE THIRD PARTIES MENTIONED ON THE SERVICES OR THE AFFILIATED SERVICES (AND ALL RELATED WEBSITES AND APPLICATIONS) BE LIABLE TO YOU OR TO ANY OTHER PERSON OR ENTITY FOR ANY DAMAGES WHATSOEVER, INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, PUNITIVE, OR OTHER DAMAGES OF ANY CHARACTER WHATSOEVER ARISING OUT OF OR IN ANY WAY RELATED TO THE USE OR INABILITY TO USE THE SERVICES, THE AFFILIATED SERVICES, RELATED WEBSITES AND APPLICATIONS, AND/OR THEIR CONTENT, OR OTHERWISE UNDER OR IN CONNECTION WITH ANY PROVISION OF THESE TERMS OF USE, EVEN IN THE EVENT OF FAULT, TORT (INCLUDING NEGLIGENCE AND GROSS NEGLIGENCE), STRICT LIABILITY, BREACH OF CONTRACT, OR BREACH OF WARRANTY BY GREYFINCH OR THE THIRD PARTIES MENTIONED ON THE SERVICES OR ANY AFFILIATED SERVICES (OR RELATED WEBSITES AND APPLICATIONS), AND EVEN IF GREYFINCH OR THE THIRD PARTIES MENTIONED ON THE SERVICES OR ANY AFFILIATED SERVICES (OR RELATED WEBSITES AND APPLICATIONS) HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME STATES AND JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION AND EXCLUSION MAY NOT APPLY TO YOU. THE FOREGOING PROVISIONS SHALL BE ENFORCEABLE TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Violation of These Terms of Use"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You agree that GREYFINCH may, in its sole discretion and without prior notice, terminate Your access to the Services and/or any related websites or applications if GREYFINCH determines in its sole discretion that You have violated these Terms of Use."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH may disclose any information it has about You, including Your identity, if it determines that such disclosure is necessary as part of any investigation or complaint regarding Your use of the Services, or to identify, contact or bring legal action against someone who may be causing injury to or interference with GREYFINCH's rights or property, or another person's rights or property. GREYFINCH reserves the right to disclose any information GREYFINCH deems necessary to comply with any applicable law, regulation, or governmental rule, and also when it determines that applicable law permits such disclosure, including exchanging information with other companies and organizations for fraud protection purposes."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You acknowledge and agree that GREYFINCH may preserve any communication by You with GREYFINCH through the Services and/or the Affiliated Services or any service offered on or through the Services and/or the Affiliated Services, and may disclose such communications when required by law or if GREYFINCH deems that such preservation or disclosure is reasonably necessary to: (1) comply with legal process; (2) enforce these Terms of Use; (3) respond to a claim that any communication, information posted on the Services, the Affiliated Services, or Content violates the rights of others; or (4) protect the rights, property or personal safety of GREYFINCH and its employees, users of or visitors to the Services and/or the Affiliated Services, and/or the public."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="If GREYFINCH takes legal action against You as a result of Your violation of these Terms of Use, GREYFINCH will be entitled to recover from You, and You agree to pay, all reasonable attorney's fees and costs of such action, in addition to any other relief granted to GREYFINCH. You agree that GREYFINCH will not be liable to You or to any third party for termination of Your access to the Services and/or the Affiliated Services or removal of any communication or posting of information by You, or contents thereof, as a result of any violation of these Terms of Use."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Void Where Prohibited"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH reserves the right to limit, in its sole discretion, the provision and quantity of any Service, Content, feature, or product to any person or geographic area, whether by reason of the local laws applicable in such geographic area or otherwise. Any offer for any feature, product, or service made on the Services and/or the Affiliated Services is void where prohibited."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Modification or Termination of the Services"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH may, in its sole and absolute discretion and without any liability, change, discontinue, make improvements to, modify, or suspend, any aspect or all of the Services and/or the Affiliated Services, temporarily or permanently, at any time and for any reason without prior notice. GREYFINCH is under no obligation to retain a record of your Account or any data or information that you may have used, disclosed, processed, retrieved, transmitted, or viewed on GREYFINCH."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Governing Law and Arbitration"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="These Terms of Use shall be governed, construed and applied in all respects by the laws of the State of Arkansas, without regard to any provision governing conflicts of law."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Any and all controversies, claims, or disputes arising out of, relating to, or connected with these Terms of Use or Your use of the Services and/or the Affiliated Services shall be referred to and settled by arbitration administered by the American Arbitration Association (“AAA”) in accordance with the provisions set forth under the AAA's Commercial Arbitration Rules and any other applicable rules and procedures (“Rules”) by a panel of three arbitrators appointed in compliance with the Rules. This includes all disputes over arbitrability."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="The Parties to this Agreement further acknowledge and agree that:"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(a) the location of the arbitration, including the location of all arbitration hearings, shall be Little Rock, Arkansas;"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(b) the arbitral award shall address the costs and expenses of arbitration and all matters related thereto, including, the allocation of same between the parties;"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(c) the award of the arbitrators shall be final and binding upon the parties; and"
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="(d) the parties submit to the jurisdiction of the federal courts of Arkansas for the purposes of ratifying any award made pursuant to arbitration proceedings conducted in accordance with this clause and/or may enforce the award through such courts."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="By using the Services and/or the Affiliated Services, You expressly waive Your right to pursue all controversies, claims, or disputes in court and instead must submit any such controversies, claims, or disputes to arbitration as described above."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Waiver of Class and Joint Claims"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Any arbitration (or, if arbitration of the action is not permitted by law, litigation) shall be solely on behalf of an individual person, and shall not be consolidated or joined with the claims of any other person or brought on behalf of a putative class unless previously agreed to in writing by both You and GREYFINCH or You and Direct Dental Care."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Title
  viewPath={`${viewPath}/Title`}
 lineHeight="26px"
 marginTop={30}
 textOverflow="none"
 whiteSpace="wrap"
 text="Miscellaneous"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="If any provision of these Terms of Use are ruled by a court or other tribunal of competent jurisdiction to be void or unenforceable, such provision(s) shall be limited or eliminated to the minimum extent necessary and replaced with a valid provision that best furthers the intent of these Terms of Use, with all remaining provisions remaining in full force and effect."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="These Terms of Use and the Privacy Policy constitute the entire agreement between You and GREYFINCH with regard to Your access and use of the Services and/or the Affiliated Services. No counter-offers to these Terms of Use shall be accepted by GREYFINCH, and GREYFINCH rejects all such counter-offers."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH may assign its rights, in whole or in part, in the Services and/or the Affiliated Services in accordance with its sole discretion."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="GREYFINCH's failure or delay to insist on or enforce strict performance of these Terms of Use shall not be construed as a waiver of any provision or any right that GREYFINCH has to enforce these Terms of Use."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="You acknowledge and agree that it is the intent of both you and GREYFINCH to limit the period of time in which a claim may be filed, even if the period is shorter than that fixed by the statute of limitations. You therefore agree that any cause of action arising out of or related to GREYFINCH must commence within one (1) year after the cause of action accrues, otherwise such cause of action is permanently barred."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="These Terms of Use do not confer any rights or remedies on any third parties."
 textOverflow="none"
 whiteSpace="wrap"
/>
<Body
  viewPath={`${viewPath}/Body`}
 marginTop={dtSpaceS}
 text="Updated on February 22, 2021."
 textOverflow="none"
 whiteSpace="wrap"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}